import { useMemo, type ReactElement } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { DataTableAlertsContent } from './DataTableAlertsTab';
import { parseOccurrencesAlertKey } from '@kirin/api-client/helpers/alerts';
import { AlertOccurrencesModal } from '@/components/grouped-alerts';
import { getOccurrencesFiltersFromSearchParams } from './DataTableAlertsTab/utils';

export default function OrgGroupAlertsTab(): ReactElement | null {
  const params = useParams<{ organizationId: string; '*': string }>();
  const { organizationId } = params;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const occurrencesAlertKey = parseOccurrencesAlertKey(params['*']);

  const occurrencesFilters = useMemo(
    () => getOccurrencesFiltersFromSearchParams(searchParams),
    [searchParams]
  );

  if (!organizationId) {
    return null;
  }

  return (
    <>
      <DataTableAlertsContent
        key={organizationId}
        organizationId={organizationId}
      />
      {occurrencesAlertKey && (
        <AlertOccurrencesModal
          open
          alertKey={occurrencesAlertKey}
          organizationId={organizationId}
          filters={occurrencesFilters}
          onClose={() => navigate(`/${organizationId}/alerts`)}
        />
      )}
    </>
  );
}
